var templateName = document.body.getAttribute("data-template-name");
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
      
      
      
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
      if (templateName === "cart") {
        this.executeOnPageLoad(); // Call the function on page load
      }
      this.executeDrawerOnPageLoad();
    });
    if (templateName === "cart") {
      this.executeOnPageLoad(); // Call the function on page load
    }
    this.executeDrawerOnPageLoad();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {

    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          this.executeDrawerOnPageLoad(); // Call the function on cart drawer update
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          this.executeDrawerOnPageLoad(); // Call the function on main cart update
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }



executeOnPageLoad() {

  // Get the element with the class "fs-bar-wrap"
  const fsBarWrap = document.querySelector('.fs-bar-wrap');
  const freeShippingLimit = fsBarWrap.getAttribute('data-free-shipping-limit');
  const maxValue = parseInt(freeShippingLimit); // Parse as integer

  const cartTotalAmount = document.getElementById('cart-total-amount');
  const textContent = cartTotalAmount.textContent;
  const numericValue = parseFloat(textContent.replace(/[^0-9.]/g, ''));

  const filledRange = document.getElementById('filledRange');
  const filledValue = numericValue;
  const filledPercentage = (filledValue / maxValue) * 100;

  // Get the element with the class "away-text"
  const awayText = document.querySelector('.away-text');
  const spanElement = awayText.querySelector('span');
  const remainingValue = maxValue - filledValue;

  // Update the text content based on the comparison
  if (numericValue >= maxValue) {
    awayText.textContent = 'Congratulations! You are eligible for free shipping!';
  } else {
    awayText.innerHTML = `You’re <span><span class="inner-symbol">£</span>${remainingValue.toFixed(2)}</span> Away from Free Shipping!`;
  }

  // Set the width of the filled range
  filledRange.style.width = `${filledPercentage}%`;
}

executeDrawerOnPageLoad() {

  // Get the element with the class "fs-bar-wrap"
  const fsBarDrawerWrap = document.querySelector('.fs-bar-drawer-wrap');
  const freeShippingLimit = fsBarDrawerWrap.getAttribute('data-free-shipping-limit');
  const maxValue = parseInt(freeShippingLimit); // Parse as integer

  const cartTotalAmount = document.getElementById('cart-drawer-total-amount');
  const textContent = cartTotalAmount.textContent;
  const numericValue = parseFloat(textContent.replace(/[^0-9.]/g, ''));

  const filledRange = document.getElementById('filledDrawerRange');
  const filledValue = numericValue;
  const filledPercentage = (filledValue / maxValue) * 100;

  // Get the element with the class "away-text"
  const awayText = document.querySelector('.drawer-away-text');
  const spanElement = awayText.querySelector('span');
  const remainingValue = maxValue - filledValue;

  // Update the text content based on the comparison
  if (numericValue >= maxValue) {
    awayText.textContent = 'Congratulations! You are eligible for free shipping!';
  } else {
    awayText.innerHTML = `You’re <span><span id="fs-symbol">£</span>${remainingValue.toFixed(2)}</span> Away from Free Shipping!`;
  }

  // Set the width of the filled range
  filledRange.style.width = `${filledPercentage}%`;
}

// Get the select element
// var currencySwitcher = document.getElementById('currency-switcher');

// // Add an event listener for the 'change' event
// currencySwitcher.addEventListener('change', function() {
//   // Log the selected value to the console
//   console.log('Selected Currency:', currencySwitcher.value);
// });  

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        if (templateName === "cart") {
          this.executeOnPageLoad(); // Call the function after the cart update
        }
        this.executeDrawerOnPageLoad();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.checkBundle();
        this.disableLoading(line);
      });
  }

  checkBundle() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let bundleItems = cart.items.filter(item => item.properties && item.properties.Bundle);
        let totalBundleQuantity = bundleItems.reduce((sum, item) => sum + item.quantity, 0);

        if (totalBundleQuantity < 3 && bundleItems.length > 0) {
          let updates = {};
          bundleItems.forEach(item => {
            updates[item.key] = 0; // Mettre la quantité à 0 pour supprimer l'article
          });

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          })
          .then(response => response.json())
          .then(() => location.reload()) // Recharger la page après la suppression
          .catch(error => console.error('Error updating cart:', error));
        }
      })
      .catch(error => console.error('Error checking bundle:', error));
}




  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}




// Based Currency Dropdown Switch, Change Symbol on Announcement bar, drawer and cart page

// Function to handle changes in the content
function handleContentChanges(mutationsList, observer) {
  for (var mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Check if the mutation occurred on the target element
      if (mutation.target.classList.contains('money')) {
        
        var currencyCode = mutation.target.getAttribute('doubly-currency');
        var currencySymbol = "£";

        // Set currency symbol based on currency code
        switch (currencyCode) {
          case "GBP":
            currencySymbol = "£";
            break;
          case "USD":
          case "CAD":
            currencySymbol = "$";
            break;
          case "EUR":
            currencySymbol = "€";
            break;
        }

        console.log('Value changed for doubly-currency ' + currencySymbol );
        
        // Update the content of the span with id="fs-symbol"
        var fsSymbolSpan = document.getElementById('fs-symbol');
        var itemText = document.querySelector('.item.two span');        
        var cartpageInnerSymbolSpan = document.querySelector('.fs-bar-wrap .inner-symbol');
        var fieldCurrencyOne = document.querySelector('.fc-one'); 
        var fieldCurrencyTwo = document.querySelector('.fc-two'); 
        
        if (itemText) {
          itemText.textContent = currencySymbol;
        }

        if (fsSymbolSpan) {
          fsSymbolSpan.textContent = currencySymbol;
        }

        if (cartpageInnerSymbolSpan) {
          cartpageInnerSymbolSpan.textContent = currencySymbol;
        }

        if (fieldCurrencyOne) {
          fieldCurrencyOne.textContent = currencySymbol;
        }

        if (fieldCurrencyTwo) {
          fieldCurrencyTwo.textContent = currencySymbol;
        }

        // After updating fs-symbol, find symbols in the announcement bar message and replace them
        replaceSymbolsInAnnouncementBar(currencySymbol);
        
      }
    }
  }
}

function replaceSymbolsInAnnouncementBar(currencySymbol) {
  var announcementMessage = document.querySelector('.announcement-bar__message');

  if (announcementMessage) {
    var messageText = announcementMessage.textContent;

    // Update the regular expression to match currency symbols directly attached to numbers
    var symbolRegex = /([£$€]\d+)/g;

    messageText = messageText.replace(symbolRegex, function(match) {
      var currencyCode = currencySymbol; // Get currency code from the first character
      var replacedSymbol = getCurrencySymbol(currencyCode);
      return replacedSymbol + match.substring(1); // Keep the number part unchanged
    });
    
    announcementMessage.innerHTML = '<span>' + messageText + '</span>';
    
    console.log("Modified Text:", messageText);
  }
}

// Function to get currency code based on currency symbol
function getCurrencyCode(symbol) {
  switch (symbol) {
    case "£":
      return "GBP";
    case "$":
      return "USD";
    case "€":
      return "EUR";
    // Add more cases for other symbols if needed
    default:
      return symbol; // Default to the provided symbol if no match
  }
}

// Function to get currency symbol based on currency code
function getCurrencySymbol(currencyCode) {
  switch (currencyCode) {
    case "£":
      return "£";
    case "$":
      return "$";
    case "€":
      return "€";
    // Add more cases for other currency codes if needed
    default:
      return currencyCode; // Default to the provided code if no match
  }
}

// Target node to observe
var targetNode = document.querySelector('.money');

// Options for the observer (mutations to observe)
var observerOptions = { childList: true, subtree: true };

// Create an observer instance linked to the callback function
var observer = new MutationObserver(handleContentChanges);

// Start observing the target node for configured mutations
observer.observe(targetNode, observerOptions);